import React, { useState } from 'react';
import { Button, Box } from '@mui/material';
import CreateCustomTrainingPage from './customTrainings/CreateCustomTrainingPage';
import CustomTrainingsListPage from './customTrainings/CustomTrainingsListPage';

const CustomTraining = () => {
  const [activePage, setActivePage] = useState('list');

  return (
    <div>
      <Box display="flex" justifyContent="center" mb={2}>
        <Button
          variant={activePage === 'list' ? 'contained' : 'outlined'}
          onClick={() => setActivePage('list')}
          style={{ marginRight: '10px' }}
        >
          Training List
        </Button>
        <Button
          variant={activePage === 'create' ? 'contained' : 'outlined'}
          onClick={() => setActivePage('create')}
        >
          Create Training
        </Button>
      </Box>

      {activePage === 'create' ? <CreateCustomTrainingPage /> : <CustomTrainingsListPage />}
    </div>
  );
};

export default CustomTraining;
